import { z } from "zod";

/**
 * Validated client-side environment.
 *
 * All variables must be prefixed `VITE_` to be exposed by Vite.
 * Missing or invalid vars throw at module load time so the app never
 * boots into a half-configured state.
 */
const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().url(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20, "VITE_SUPABASE_ANON_KEY missing"),
  VITE_API_BASE_URL: z.string().url(),
  VITE_PUBLIC_BASE_URL: z.string().url(),
  VITE_ALLOWED_EMAIL: z.string().email(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  // Surface configuration error early — don't let the app boot half-configured.
  console.error("[env] invalid configuration:", parsed.error.flatten().fieldErrors);
  throw new Error(
    "Missing or invalid VITE_* env vars. See apps/hq/.env.example.",
  );
}

export const env = parsed.data;
export type Env = z.infer<typeof envSchema>;
